import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import themes, { THEME_TYPES } from '@Styles/Themes';

import { addEmptyChoice } from '@Services/Editor';

import { ReactComponent as AddSVG } from '@Assets/Svgs/ic_add.svg';
import Button from '@Components/Common/Button';

const AddingChoiceButton = ({ processId }) => {
  const dispatch = useDispatch();
  const theme = themes[THEME_TYPES.LIGHT];

  const onAddEmptyProcesses = useCallback(() => {
    dispatch(addEmptyChoice({ processId }));
  }, [dispatch]);

  return (
    <Button
      isTextOnly={false}
      style={{ borderRadius: '47px', height: '20px' }}
      backgroundColor={theme.colors.ui_1}
      borderColor={theme.colors.ui_4}
      borderWidth={1}
      onClick={onAddEmptyProcesses}
    >
      <AddIconWrapper>
        <AddIcon />
      </AddIconWrapper>
    </Button>
  );
};

const AddIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 16px;
  height: 16px;

  margin: 2px 0px;
`;

const AddIcon = styled(AddSVG)`
  width: 16px;
  height: 16px;

  stroke: ${({ theme }) => theme.colors.ui_on_3};
`;

export default AddingChoiceButton;
